import { api, apiMain } from './config/axios';

export const getAuditLogs = (params = {}) => api.get('/api/v1/admin/audit-logs', params);

export const getMainAuditLogs = (params = {}) => apiMain.get('/api/v1/admin/audit-logs', params);
